// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"05243a55","361":"d33c1d88","487":"3395fbc1"}[chunkId] + ".chunk.js";
};